import { COLORS } from "@/app/common/consts/colors";
import React from "react";
import type { IconProps } from "./type";

const AmenitiesTick = ({ color = "lightblack" }: IconProps) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.95825 10.7917L7.12492 13.9583L15.8333 5.25"
        stroke="#0068FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AmenitiesTick;
